<template>
    <div class="account-menu">
        <ul class="dropdown-content">
            <li>
                <div class="account-button">
                    <a id="profile" v-on:click="toggleAccountSettings()">{{$t('str.MyProfile')}}</a>
                </div>
            </li>
            <li>
                <div class="account-button">
                    <a id="logout" v-on:click="Logout()">{{$t('str.Logout')}}</a>
                </div>
            </li>
        </ul>
        <profilemanagement v-if="modalOpen" v-on:closeModal="close" :user="user" :service="service"></profilemanagement>
    </div>
</template>

<script>

import ProfileManagement from '@/components/ProfileManagement';
import {EventBus} from '../router/index';

export default {
    components: {
        profilemanagement: ProfileManagement
    },

    props: {
        user: Object,
        service: Object
    },

    data() {
        return {
            modalOpen: false
        };
    },

    methods: {
        toggleAccountSettings() {
            this.modalOpen = !this.modalOpen;
        },
        
        Logout() {
            EventBus.$emit('logout');
        },

        close() {
            this.modalOpen = false;
        }
    }
};

</script>

<style lang="scss">

.account-menu {
    top: 10%;
    left: 95%;
    right: 0px;    
    margin: 0 auto;
    margin-right: 0px;
    z-index: 5000;       
    max-height: 650px;
    width: 90px;
    will-change: width, height;
    background-color: #fff;
    border-radius: 0px;
    overflow: hidden;
    box-shadow: none;
    display: block;       
    text-decoration: none;
    font-size: 1rem;
    font-weight: normal;
    line-height: 1.5;
    font-family: "Poppins", "Helvetica Neue", Helvetica, Arial, sans-serif;

     ul {
        list-style-type: none;
        padding: 0;
    }

    .dropdown-content {
        position: absolute;            
        width: 62px;
        display: block;
        z-index: 1000;
        background-color: #fff;
        margin: 0 0 0 0;
        min-width: 90px;           
        overflow-y: auto;                      

        li {          
            min-height: 50px;
            line-height: 1rem;
            width: 100%;
            text-align: center;
            font-size: 0.7em;
            float: left;
            padding: 0;
            cursor: pointer;
            text-decoration: none;

            .account-button {
                border-bottom: 1px solid #e0e0e0;
                border-left: 1px solid #e0e0e0;
                border-right: 1px solid #e0e0e0;
            }

            a {
                font-size: 1.2em;
                color: #d4451d;
                display: block;
                padding: 20px 10px;    
                user-select: none;              
            }

            a:hover {
                background-color: #e0e0e0;
            }
        }
    }    
}

</style>


// WEBPACK FOOTER //
// AccountMenu.vue?2e3ea2cd